import * as uuid from 'uuid'
import {
  notificationSeverity,
  notificationTypeConfig,
  notificationTypes
} from '../../components/Default/NotificationCenter/constants'

/**
 * Normalizes a partial notification into the shape stored in redux.
 * Any field can be provided by the caller; missing fields get sensible defaults
 * so notifications can be injected with as little as `{ type }` or `{ payload }`.
 *
 * @param {Object} notification
 * @param {string} [notification.id]
 * @param {string} [notification.type]
 * @param {string} [notification.severity]
 * @param {boolean} [notification.read]
 * @param {number} [notification.createdAt] epoch milliseconds
 * @param {Object} [notification.payload] type-specific data
 */
const normalize = (notification = {}) => {
  const type = notification.type ?? notificationTypes.GENERIC
  return {
    id: notification.id ?? uuid.v4(),
    type,
    severity: notification.severity ?? notificationTypeConfig[type]?.severity ?? notificationSeverity.INFO,
    read: notification.read ?? false,
    createdAt: notification.createdAt ?? Date.now(),
    payload: notification.payload ?? {},
  }
}

const push = (notification) => ({ type: 'NOTIFICATIONS_PUSH', payload: normalize(notification) })
const dismiss = (id) => ({ type: 'NOTIFICATIONS_DISMISS', payload: id })
const dismissAll = () => ({ type: 'NOTIFICATIONS_DISMISS_ALL' })
const markRead = (id) => ({ type: 'NOTIFICATIONS_MARK_READ', payload: id })
const markAllRead = () => ({ type: 'NOTIFICATIONS_MARK_ALL_READ' })
const open = () => ({ type: 'NOTIFICATIONS_OPEN' })
const close = () => ({ type: 'NOTIFICATIONS_CLOSE' })
const toggle = () => ({ type: 'NOTIFICATIONS_TOGGLE' })

export const notificationsActions = {
  push,
  dismiss,
  dismissAll,
  markRead,
  markAllRead,
  open,
  close,
  toggle,
}
